<template>
  <a class="bottom-bar" :href="url">
    <img class="bottom-bar-logo" src="https://zkres3.myzaker.com/static/wap/images/wap_logo.png">
    <img class="bottom-bar-open" src="http://zkres.myzaker.com/static/wap/images/open_zk.png">
  </a>
</template>

<script>
export default {
  name: 'BottomBar',
  props: {
    url: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-bar{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 100%;
  left: 0;
  z-index: 10;
  width: 100vw;
  margin: 0 auto;
  padding: 0 14px;
  height: 42px;
  border-top: 1px solid #e8e8e8;
  background-color: #fff;
  animation: show-up 0.5s forwards;
  cursor: pointer;
}
.bottom-bar-logo{
  height: 27px;
  width: 90px;
}
.bottom-bar-open{
  height: 27px;
  width: 70px;
}
@keyframes show-up {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, -100%, 0);
  }
}
</style>
